export default __webpack_public_path__ + "static/media/16-large.f36a9646.jpg";